export const GET_RESEARCH_DISCOVER_REQUEST = 'GET_RESEARCH_DISCOVER_REQUEST'
export const GET_RESEARCH_DISCOVER_SUCCESS = 'GET_RESEARCH_DISCOVER_SUCCESS'
export const GET_RESEARCH_DISCOVER_ERROR = 'GET_RESEARCH_DISCOVER_ERROR'
